import React from 'react';

const Error = (props) => {
    const {
        message = 'An error occurred.',
        style   = {}
    } = props;

    const renderSingleMessage = () => {
        return (
            <span>{message}</span>
        )
    }

    const renderMultipleMessages = () => {
        return (
            <ul className={"mb-0"}>
                {message.map((text, index) => (
                    <li key={index}>{text}</li>
                ))}
            </ul>
        );
    }

    const renderMessages = () => {
        if (Array.isArray(message)) {
            return renderMultipleMessages();
        }

        return renderSingleMessage();
    }

    return (
        <div className={"error-container"} style={style}>
            {renderMessages()}
        </div>
    );
}

export default Error;
